<div class="container">
  <div class="row center">
    <div class="col col-50 white">
      @if (loading) {
        <app-spinner
          [display]="true"
          [class]="'spinner-container'"
          [messageToDisplay]="'Logging you in...'"
        ></app-spinner>
      }
      @if (error) {
        <p role="alert">{{ error }}</p>
      }
    </div>
  </div>
</div>
